/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import DlvrCalendar from 'app/components/Queue/DlvrCalendar.jsx';
import Content from 'app/components/common/Content.jsx';
import Loading from 'app/components/common/Loading.jsx';
import QueueTabs from 'app/components/Queue/QueueTabs.jsx';
import CalendarDetailDrawer from 'app/components/Queue/CalendarComponents/CalendarDetailDrawer.jsx';
import { AnimatePresence, motion } from 'motion/react';
import Utilities from 'app/utility/Utilities.js';

class CalendarView extends React.Component {
    constructor(props) {
        super(props);

        let startDate = new moment().year(moment().year()).month(moment().month()).date(1),
            endDate = new moment().year(moment().year()).month(moment().month()).date(31);

        this.state = {
            isFirstLoad: false,
            startDate: startDate,
            endDate: endDate,
            events: [],
            isDrawerOpen: false,
            drawerDate: null,
            drawerId: 0,
            currentView: 'month',
            eventFilter: ''
        };

        this.prepareEvents = this.prepareEvents.bind(this);
        this.navigateCallback = this.navigateCallback.bind(this);
        this.showDrawer = this.showDrawer.bind(this);
        this.setDrawerDate = this.setDrawerDate.bind(this);
        this.getSourceIcon = this.getSourceIcon.bind(this);
        this.changeView = this.changeView.bind(this);
        this.filterEvents = this.filterEvents.bind(this);
        this.isPostOfType = this.isPostOfType.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        if (props.router.query !== null && props.router.query.view !== undefined) {
            if (['month', 'week'].indexOf(props.router.query.view) !== -1) {
                return {
                    currentView: props.router.query.view
                };
            }
        }

        return null;
    }

    componentDidMount() {

        if (this.state.isFirstLoad === false && this.props.social && this.props.social.id) {
            this.props.getCalendar({
                socialId: this.props.social.id,
                startTs: parseInt(new moment(this.state.startDate).subtract(1, 'week').format('X')),
                endTs: parseInt(new moment(this.state.endDate).add(1, 'week').format('X'))
            });

            this.setState({
                isFirstLoad: true
            })
            
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Calendar View Loaded'
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.isFirstLoad === false && this.props.social && this.props.social.id ||
            (prevProps && prevProps.social && prevProps.social.id != this.props.social.id)) {
            this.props.getCalendar({
                socialId: this.props.social.id,
                startTs: parseInt(new moment(this.state.startDate).subtract(1, 'week').format('X')),
                endTs: parseInt(new moment(this.state.endDate).add(1, 'week').format('X'))
            });
            this.setState({
                isFirstLoad: true,
                isDrawerOpen: false,
                drawerDate: null,
                drawerId: 0
            });
        }

        if (prevProps && prevProps.app.loading.QUEUE_CALENDAR_LIST === true && this.props.app.loading.QUEUE_CALENDAR_LIST === false) {
            this.setState({
                events: this.prepareEvents()
            });
        }

        if (prevProps && prevProps.app.loading.QUEUE_DELETE === true && this.props.app.loading.QUEUE_DELETE === false) {
            this.props.getCalendar({
                socialId: this.props.social.id,
                startTs: parseInt(new moment(this.state.startDate).subtract(1, 'week').format('X')),
                endTs: parseInt(new moment(this.state.endDate).add(1, 'week').format('X'))
            });
        }

    }

    prepareEvents(filter) {
        let eventList = [];

        let eventFilter = this.state.eventFilter;
        if (filter !== undefined) {
            eventFilter = filter;
        }

        if (this.props.queue.calendar.list.length) {
            eventList = Utilities.deepClone(this.props.queue.calendar.list);

            // filter events if necessary
            if (eventFilter !== '') {
                let filteredList = [];
                eventList.map((item) => {
                    if (this.isPostOfType(item, eventFilter)) {
                        filteredList.push(item);
                    }
                });

                eventList = filteredList;
            }

        }

        return eventList;

    }

    navigateCallback(nextDate) {

        let startDate = null,
            endDate = null;

        // check if it's an object
        if (nextDate) {
            if (nextDate.month() !== this.state.startDate.month()) {

                startDate = new moment(nextDate).date(1);
                endDate = new moment(nextDate).date(nextDate.daysInMonth());
                this.setState({
                    startDate,
                    endDate
                }, () => {
                    this.props.getCalendar({
                        socialId: this.props.social.id,
                        startTs: parseInt(new moment(this.state.startDate).subtract(1, 'week').format('X')),
                        endTs: parseInt(new moment(this.state.endDate).add(1, 'week').format('X'))
                    });
                });
            }
        }

    }

    showDrawer(state, id, date) {
        let isDrawerOpen = false,
            drawerDate = null,
            drawerId = null;

        if (state) {
            isDrawerOpen = true;
            drawerDate = date;
            drawerId = id;
        }

        this.setState({
            isDrawerOpen,
            drawerDate,
            drawerId
        });

    }

    setDrawerDate(newDate) {
        this.setState({
            drawerDate: newDate,
            drawerId: 0
        });
    }

    getSourceIcon(dlvrSrc) {
        let icon = null,
            className = '',
            icons = {
                queue: 'ds-icon icon-queue',
                scheduled: 'con ion-android-alarm-clock',
                everq: 'ds-icon icon-everqueue',
                echo: 'ds-icon icon-replay-queue',
                automated: 'icon ion-forward',
                manual: 'icon ion-ios-compose-outline'
            };

            if (dlvrSrc.queue) {
                if (dlvrSrc.scheduled) {
                    className = 'scheduled';
                    icon = (
                        <i className={icons.scheduled}/>
                    );
                } else if (dlvrSrc.echo) {
                    className = 'echo';
                    icon = (
                        <i className={icons.echo}/>
                    );
                } else {
                    className = 'queue';
                    icon = (
                        <i className={icons.queue}/>
                    );
                }

            } else if (dlvrSrc.everq) {
                className = 'everqueue';
                icon = (
                    <i className={icons.everq}/>
                );
            } else {
                className = 'automated';
                icon = (
                    <i className={icons.automated}/>
                );
            }

        return [icon, className];
    }

    changeView(nextView) {
        if (['month', 'week'].indexOf(nextView) !== -1) {
            this.setState({
                currentView: nextView
            });
        }
    }

    filterEvents(filter) {

        this.setState({
            eventFilter: filter,
            events: this.prepareEvents(filter)
        });

    }

    isPostOfType(postData, type) {
        let { dlvrSrc } = postData;

        if (dlvrSrc.queue) {
            if (dlvrSrc.scheduled && type === 'scheduled') {
                return true;
            } else if (dlvrSrc.everq && type === 'queue') {
                return true;
            } else if (dlvrSrc.echo && type === 'scheduled') {
                return true;
            } else if (type === 'queue') {
                return true;
            }

        } else if (type === 'direct') {
            return true;
        }

        return false;

    }

    render() {
        let main = null,
            drawer = <div></div>;

		let tabs = (
    			<QueueTabs
    				{...this.props}
                    fixed={this.state.fixedHeader}
    				active={this.state.queueActiveTab}
                    onCategoryFilter={this.onCategoryFilter}
                    currentQueueView={this.state.currentView}
                    source="calendar"/>
        );


        drawer = (
            <CalendarDetailDrawer
                {...this.props}
                showDrawer={this.showDrawer}
                drawerId={this.state.drawerId}
                drawerDate={this.state.drawerDate}
                setDrawerDate={this.setDrawerDate}
                getSourceIcon={this.getSourceIcon}
                currentFilter={this.state.eventFilter}
                isPostOfType={this.isPostOfType}
                startDate={this.state.startDate}
                endDate={this.state.endDate}/>
        );


        if (this.props.isFirstLoad === false) {
            main = (<Loading/>);
        } else {
            main = (
                <div className="dlvr-calendar-main">
                    <DlvrCalendar
                        {...this.props}
                        events={this.state.events}
                        showDrawer={this.showDrawer}
                        getSourceIcon={this.getSourceIcon}
                        navigateCallback={this.navigateCallback}
                        currentView={this.state.currentView}
                        filterEvents={this.filterEvents}
                        currentFilter={this.state.eventFilter}
                        timezone={this.props.user.detail.timezone}/>
                    <AnimatePresence>
                        {this.state.isDrawerOpen ? (
                            <motion.div
                                className="dlvr-calendar-drawer"
                                initial={{
                                    transform: "translateX(100%)"
                                }}
                                animate={{
                                    transform: "translateX(0%)"
                                }}
                                exit={{
                                    transform: "translateX(100%)"
                                }}
                                transition={{
                                    duration: 0.5,
                                    ease: "easeInOut"
                                }}>
                                {drawer}
                            </motion.div>
                        ) : null}
                    </AnimatePresence>
                </div>
            );
        }

        return (
            <Content
                header={tabs}
                main={main}/>
        );
    }
}

export default ComponentWithContext(CalendarView);
